import React from 'react'
import {
    Box,
    Button,
    Image,
    Link,
    List,
    ListIcon,
    ListItem,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Text,
} from '@chakra-ui/react'
import { chakra } from '@chakra-ui/system'
import { CheckmarkCircle2Outline } from '@emotion-icons/evaicons-outline/CheckmarkCircle2Outline'
import { ArrowRight } from '@emotion-icons/feather'
import { Packages } from 'entities/packages'
import { routes } from 'routes'
import { emoji } from 'lib/emoji'
import { Modal } from 'components/modal'
import Rocket from 'public/img/rocket_on_pedestal.png'

const ArrowRightIcon = chakra(ArrowRight)

export const TrialStartedModal = ({
    isOpen,
    onClose,
}: {
    isOpen: boolean
    onClose: () => void
}) => {
    return (
        <Modal hideCloseBtn={false} isOpen={isOpen} onClose={onClose} size="lg">
            <ModalHeader>
                <>
                    <Text
                        variant="bodyTextSmall"
                        fontWeight="600"
                        marginBottom="16px"
                        color="semantic.success.accent_light"
                    >
                        <Box mr={'3px'} display={'inline'}>
                            {emoji.confetti}
                        </Box>
                        Your job is now live
                    </Text>
                    <Box>Have more roles to advertise?</Box>
                </>
            </ModalHeader>
            <ModalBody>
                <Text mb={{ base: '12px', md: '20px' }}>
                    Switch to{' '}
                    <Box display={'inline'} fontWeight={600} as="span">
                        {Packages.LaunchPad.name}
                    </Box>{' '}
                    package to get the best out of the WorksHub communities
                </Text>
                <Box
                    borderRadius={'12px'}
                    backgroundColor={'gray.background'}
                    p={'20px 24px 24px'}
                    position="relative"
                >
                    <Text variant="bodyTextMedium" fontWeight="600">
                        {Packages.LaunchPad.name}
                    </Text>
                    <Text mb={'16px'} fontSize={'14px'} lineHeight={'24px'}>
                        From{' '}
                        <Text
                            variant="bodyTextMedium"
                            fontWeight="600"
                            display={'inline'}
                        >
                            {Packages.LaunchPad.startingPrice}
                        </Text>{' '}
                        /mo
                    </Text>
                    <Image src={Rocket.src} position="absolute" top="20px" right="24px" />
                    <List mb={'12px'} spacing={'6px'}>
                        {Packages.LaunchPad.perks.map(perk => {
                            return (
                                <ListItem key={perk} display="flex" alignItems="center">
                                    <ListIcon
                                        as={CheckmarkCircle2Outline}
                                        color="secondary.500"
                                    />
                                    <Text fontSize="14px">{perk}</Text>
                                </ListItem>
                            )
                        })}
                    </List>
                    <Link
                        href={routes.paymentPackages()}
                        variant="functionalSemiBold"
                        color="secondary.text"
                        display="flex"
                        alignItems="center"
                        gridGap="8px"
                        fontWeight="600"
                    >
                        Learn more
                        <ArrowRightIcon boxSize="19px" strokeWidth={1.5} />
                    </Link>
                </Box>
            </ModalBody>
            <ModalFooter flexDirection={{ base: 'column', md: 'row' }}>
                <Button variant="secondary" size="modalFooter" onClick={onClose}>
                    Continue free trial
                </Button>
                <Button
                    variant="primary"
                    as="a"
                    href={routes.paymentPackages()}
                    size="modalFooter"
                >
                    Upgrade now
                </Button>
            </ModalFooter>
        </Modal>
    )
}
